import { useTerminalStore } from '../store/useTerminalStore';
import { useTranslation } from '../i18n/useTranslation';

/**
 * DDD #180 S1 — visible degraded-data state.
 *
 * Renders a prominent, persistent banner whenever the gateway bootstrap failed
 * and the webapp fell back to simulated data (`dataSource === 'degraded'`).
 * Replaces the prior SILENT mock-in-production path (useBootstrap seedFromMock),
 * so beta users are never shown fake numbers without warning.
 */
export function DegradedDataBanner() {
  const dataSource = useTerminalStore((s) => s.dataSource);
  const { t } = useTranslation();

  if (dataSource !== 'degraded') return null;

  return (
    <div
      role="alert"
      data-testid="data-mode-degraded"
      className="flex items-center gap-2 h-7 px-4 shrink-0 bg-red-600/90 text-white text-[11px] font-mono uppercase tracking-wide border-b border-red-800"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" aria-hidden="true" />
      {t('degraded.banner')}
    </div>
  );
}
